import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { BenefitsSection } from './components/BenefitsSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#0a0a0a] text-zinc-100 font-sans selection:bg-amber-500/30 selection:text-amber-200" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainSection data-id="element-4" />
        <BenefitsSection data-id="element-5" />
        <CTASection data-id="element-6" />
      </main>
      <Footer data-id="element-7" />
    </div>;
}